/* eslint-disable */

/**
 * Dependencies:
 * - Custom select component
 *
 * Required translation strings:
 * - addToCart
 * - noStock
 * - noVariant
 * - onlyXLeft
 */

function calcSubtotal(price, quantity) {
  const priceNumber = Number(price.replace('$', '').replace(/,/g, ''));
  const qty = Number(quantity);
  return `$${(priceNumber * qty).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}`;
}

if (!customElements.get('variant-picker')) {
  class VariantPicker extends HTMLElement {
    constructor() {
      super();
      this.section = this.closest('.js-product');
      this.productForm = this.section.querySelector('.js-product-form-main');
      this.optionSelectors = this.querySelectorAll('.option-selector');
      this.data = this.getProductData();
      this.variant = this.getSelectedVariant();
      this.selectedOptions = this.getSelectedOptions();
      this.preSelection = !this.variant && this.selectedOptions.find((o) => o === null) === null;
      this.quantityInputEl = this.section.querySelector('input[name="quantity"]');

      this.addEventListener('change', this.handleVariantChange.bind(this));
      this.updateAvailableForRetail();
      this.updateSpecsVisibility();
      this.updateShortTitle();

      document.addEventListener('wcQuantity::Changed', this.updatePrice.bind(this));
      
      // Defer these to allow for quick-add modal to full initialize
      setTimeout(() => {
        // this.quantityInputEl?.addEventListener('change', this.updatePrice.bind(this));
        this.updateAvailability();
        this.updateAddToCartButton();
      });
    }

    /**
     * Handles 'change' events on the variant picker element.
     * @param {object} evt - Event object.
     */
    handleVariantChange(evt) {
      const sectionId = this.section.dataset.section;
      this.selectedOptions = this.getSelectedOptions();
      this.variant = this.getSelectedVariant();
      this.preSelection = !this.variant && this.selectedOptions.find((o) => o === null) === null;
      if (this.variant) {
        fetch(`/products/${this.data.product.handle}?variant=${this.variant.id}${sectionId ? `&section_id=${sectionId}` : ''}`)
          .then(res => res.text())
          .then(data => {
            // Convert raw HTML text to a queryable DOM element
            const parser = new DOMParser();
            this.sectionHTMLData = parser.parseFromString(data, 'text/html');
            if (this.variant) {
              this.updateMedia();
              this.updateUrl(evt);
              this.updateVariantInput();
            }

            this.updateAddToCartButton();
            this.updateAvailability();
            this.updatePrice();
            this.updateWeight();
            this.updateBarcode();
            this.updateBackorderText();
            this.updatePickupAvailability();
            this.updateSku();
            this.updateCatalogNo();
            this.updateCompatibleSynthesizer();
            this.updateShortTitle();
            this.updateAvailableForRetail();
            this.updateHighlightedSpecs();
            this.updateSpecsTab();
            this.updateMetafieldContent();
            this.updateEstimateArriveDate();
            this.updateEstimateRestockDate();
            this.updateMetafieldVisibility();
            // this.updateQuantityInput();
            VariantPicker.updateLabelText(evt);

            if (!this.preSelection) {
              this.dispatchEvent(new CustomEvent('on:variant:change', {
                bubbles: true,
                detail: {
                  form: this.productForm,
                  variant: this.variant,
                  product: this.data.product
                }
              }));
            }
          })
          .catch(err => {
            console.log(err, 'err')
          })
      } else {
        this.updateAddToCartButton();
        this.updateAvailability();
        this.updatePrice();
        this.updateWeight();
        this.updateBarcode();
        this.updateBackorderText();
        this.updatePickupAvailability();
        this.updateSku();
        this.updateCatalogNo();
        this.updateCompatibleSynthesizer();
        this.updateShortTitle();
        this.updateAvailableForRetail();
        this.updateHighlightedSpecs();
        this.updateSpecsTab();
        this.updateMetafieldContent();
        this.updateEstimateArriveDate();
        this.updateEstimateRestockDate();
        this.updateMetafieldVisibility();
        // this.updateQuantityInput();
        VariantPicker.updateLabelText(evt);

        if (!this.preSelection) {
          this.dispatchEvent(new CustomEvent('on:variant:change', {
            bubbles: true,
            detail: {
              form: this.productForm,
              variant: this.variant,
              product: this.data.product
            }
          }));
        }
      }
    }

    /**
     * Shows/hides variant metafield elements on the page as necessary
     */
    updateMetafieldVisibility() {
      this.section.querySelectorAll('[data-variant-metafield]').forEach((elem) => {
        elem.classList.toggle('hidden', elem.dataset.variantMetafield !== this.variant?.id.toString());
      });

      this.updateSpecsVisibility();
    }

    updateSpecsVisibility() {
      const tab = this.section.querySelector('#tab-4');
      const collapsibleItem = this.section.querySelector('details-disclosure[data-type="specs"]');
      const productSpecs = this.section.querySelector('ul.product-spec');
      if (!productSpecs) return;
      let hasVisibleItem = false;
      const specValues = productSpecs.querySelectorAll('.product-spec__value [data-variant-metafield]');
      specValues?.forEach(item => {
        if (!item.classList.value.includes('hidden') && !!item.innerHTML.trim()) {
          hasVisibleItem = true;
        }
      })

      this.section.querySelectorAll('ul.product-spec')?.forEach(item => {
        item.classList.toggle('hidden', !hasVisibleItem);
      })
      tab?.classList.toggle('hidden', !hasVisibleItem);
      collapsibleItem?.classList.toggle('hidden', !hasVisibleItem);

      const productSpecItems = this.section.querySelectorAll('li.product-spec__item');
      productSpecItems.forEach(item => {
        const specValues = item.querySelectorAll('.product-spec__value [data-variant-metafield]');
        let hasVisibleItem = false;
        specValues?.forEach(item => {
          if (!item.classList.value.includes('hidden') && !!item.innerHTML.trim()) {
            hasVisibleItem = true;
          }
        })
        item.classList.toggle('hidden', !hasVisibleItem);
      })
    }

    /**
     * Updates the "Add to Cart" button label and disabled state.
     */
    updateAddToCartButton() {
      this.productForm = this.section.querySelector('.js-product-form-main');
      if (!this.productForm) return;

      this.addBtn = this.addBtn || this.productForm.querySelector('[name="add"]');
      const variantAvailable = this.variant && this.variant.available;

      this.addBtn.disabled = !variantAvailable || this.preSelection;

      if (this.preSelection) {
        this.addBtn.textContent = theme.strings.noSelectedVariant;
      } else {

        const unavailableStr = this.variant ? theme.strings.noStock : theme.strings.noVariant;
        this.addBtn.textContent = variantAvailable
          ? this.addBtn.dataset.addToCartText
          : unavailableStr;
      }
    }

    /**
     * Updates the availability status of an option.
     * @param {Element} optionEl - Option element.
     * @param {boolean} exists - Does this option lead to a variant that exists?
     * @param {boolean} available - Does this option lead to a variant that is available to buy?
     */
    static updateOptionAvailability(optionEl, exists, available) {
      const el = optionEl;
      const unavailableText = exists ? theme.strings.noStock : theme.strings.noVariant;
      el.classList.toggle('is-unavailable', !available);
      el.classList.toggle('is-nonexistent', !exists);

      if (optionEl.classList.contains('custom-select__option')) {
        const em = el.querySelector('em');

        if (em) {
          em.hidden = available;
        }

        if (!available) {
          if (em) {
            em.textContent = unavailableText;
          } else {
            el.innerHTML = `${el.innerHTML} <em class="pointer-events-none">${unavailableText}</em>`;
          }
        }
      } else if (!available) {
        el.nextElementSibling.title = unavailableText;
        // el.nextElementSibling.classList.add('hidden');
      } else {
        el.nextElementSibling.removeAttribute('title');
        // el.nextElementSibling.classList.remove('hidden');
      }
    }

    /**
     * Updates the availability status in option selectors.
     */
    updateAvailability() {
      if (this.dataset.showAvailability === 'false') return;
      const { availabilityMethod } = this.dataset; // 'downward' or 'selection'
      let currVariant = this.variant;

      if (!this.variant) {
        currVariant = { options: this.selectedOptions };
      }

      if (availabilityMethod === 'selection') {
        // Flag all options as unavailable
        this.querySelectorAll('.js-option').forEach((optionEl) => {
          VariantPicker.updateOptionAvailability(optionEl, false, false);
        });

        // Flag selector options as available or sold out, depending on the variant availability
        this.optionSelectors.forEach((selector, selectorIndex) => {
          this.data.product.variants.forEach((variant) => {
            let matchCount = 0;

            variant.options.forEach((option, optionIndex) => {
              if (option === currVariant.options[optionIndex] && optionIndex !== selectorIndex) {
                matchCount += 1;
              }
            });

            if (matchCount === currVariant.options.length - 1) {
              const options = selector.querySelectorAll('.js-option');
              const optionEl = Array.from(options).find((opt) => {
                if (selector.dataset.selectorType === 'dropdown') {
                  return opt.dataset.value === variant.options[selectorIndex];
                }
                return opt.value === variant.options[selectorIndex];
              });

              if (optionEl) {
                VariantPicker.updateOptionAvailability(optionEl, true, variant.available);
              }
            }
          });
        });
      } else {
        this.optionSelectors.forEach((selector, selectorIndex) => {
          const options = selector.querySelectorAll('.js-option:not([data-value=""])');
          options.forEach((option) => {
            const optionValue = selector.dataset.selectorType === 'dropdown' ? option.dataset.value : option.value;
            // any available variants with previous options and this one locked in?
            let variantsExist = false;
            let variantsAvailable = false;
            this.data.product.variants.forEach((v) => {
              let matches = 0;
              for (let i = 0; i < selectorIndex; i += 1) {
                if (v.options[i] === this.selectedOptions[i] || this.selectedOptions[i] === null) {
                  matches += 1;
                }
              }
              if (v.options[selectorIndex] === optionValue && matches === selectorIndex) {
                variantsExist = true;
                if (v.available) {
                  variantsAvailable = true;
                }
              }
            });
            VariantPicker.updateOptionAvailability(option, variantsExist, variantsAvailable);
          });
        });
      }
    }

    /**
     * Updates the backorder text and visibility.
     */
    updateBackorderText() {
      this.backorder = this.backorder || this.section.querySelector('.backorder');
      if (!this.backorder || !this.variant?.id) return;

      let hideBackorder = true;

      if (this.variant && this.variant.available) {
        const { inventory } = this.data.formatted[this.variant.id];

        if (this.variant.inventory_management && inventory === 'none') {
          const backorderProdEl = this.backorder.querySelector('.backorder__product');
          const prodTitleEl = this.section.querySelector('.product-title');
          const variantTitle = this.variant.title.includes('Default')
            ? ''
            : ` - ${this.variant.title}`;

          backorderProdEl.textContent = `${prodTitleEl.textContent}${variantTitle}`;
          hideBackorder = false;
        }
      }

      this.backorder.hidden = hideBackorder;
    }

    /**
     * Updates the color option label text.
     * @param {object} evt - Event object
     */
    static updateLabelText(evt) {
      const selector = evt.target.closest('.option-selector');
      if (selector.dataset.selectorType === 'dropdown') return;

      const colorText = selector.querySelector('.js-color-text');
      if (!colorText) return;

      colorText.textContent = evt.target.nextElementSibling.querySelector('.js-value').textContent;
    }

    /**
     * Updates the product media.
     */
    updateMedia() {
      if (!this.variant.featured_media) return;

      if (this.section.matches('quick-add-drawer')) {
        this.section.updateMedia(this.variant.featured_media.id);
      } else {
        this.mediaGallery = this.mediaGallery || this.section.querySelector('media-gallery');
        if (!this.mediaGallery) return;

        const variantMedia = this.mediaGallery.querySelector(
          `[data-media-id="${this.variant.featured_media.id}"]`
        );
        this.mediaGallery.setActiveMedia(variantMedia, true, true);
      }
    }

    /**
     * Updates the pick up availability.
     */
    updatePickupAvailability() {
      this.pickUpAvailability =
        this.pickUpAvailability || this.section.querySelector('pickup-availability');
      if (!this.pickUpAvailability || !this.variant?.id) return;

      if (this.variant && this.variant.available) {
        this.pickUpAvailability.getAvailability(this.variant.id);
      } else {
        this.pickUpAvailability.removeAttribute('available');
        this.pickUpAvailability.innerHTML = '';
      }
    }

    /**
     * Updates the price.
     */
    updatePrice() {
      const variantId = this?.variant?.id;
      if (!variantId) return;
      // const priceData = this?.data?.formatted[variantId];
      // const quantityInputEl = this.section.querySelector('input[name="quantity"]');

      // if (priceData) {
      //   let priceCurrent = priceData?.priceValue
      //   let priceWas = priceData?.compareAtPriceValue
      //   if (priceData?.memberPriceValue) {
      //     priceCurrent = priceData?.memberPriceValue
      //     priceWas = priceData?.compareAtPriceValue || priceData?.priceValue
      //   }

      //   if (!priceWas || priceWas === priceCurrent) {
      //     priceWas = ''
      //   }
      //   const calculatedSubtotalPriceCurrent = calcSubtotal(priceCurrent.toString(), quantityInputEl.value)
      //   const calculatedSubtotalPriceWas = priceWas ? calcSubtotal(priceWas.toString(), quantityInputEl.value) : ''
      //   const calculatedUnitPriceCurrent = calcSubtotal(priceCurrent.toString(), 1)
      //   const calculatedUnitPriceWas = priceWas ? calcSubtotal(priceWas.toString(), 1) : ''

      //   const quickAddSubtotalPriceContainerEl = this.section.querySelector('.quick-add-subtotal-info');
      //   const quickAddSubtotalPriceEl = quickAddSubtotalPriceContainerEl?.querySelector?.('[data-subtotal-member-price]');
      //   if (quickAddSubtotalPriceEl && priceCurrent) {
      //     quickAddSubtotalPriceEl.innerHTML = calculatedSubtotalPriceCurrent
      //   }
  
      //   const quickAddSubtotalPriceWasEl = quickAddSubtotalPriceContainerEl?.querySelector?.('[data-subtotal-member-price-was-value]');
      //   if (quickAddSubtotalPriceWasEl) {
      //     quickAddSubtotalPriceWasEl.innerHTML = calculatedSubtotalPriceWas
      //   } else {
      //     const newQuickAddSubtotalPriceWasEl = document.createElement('s');
      //     newQuickAddSubtotalPriceWasEl.classList.add('price__was');
      //     newQuickAddSubtotalPriceWasEl.setAttribute('data-subtotal-member-price-was', '');
      //     newQuickAddSubtotalPriceWasEl.setAttribute('data-subtotal-member-price-was-value', priceWas);
      //     newQuickAddSubtotalPriceWasEl.innerHTML = calculatedSubtotalPriceWas

      //     quickAddSubtotalPriceContainerEl?.appendChild?.(newQuickAddSubtotalPriceWasEl);
      //   }

      //   const quickAddUnitPriceContainerEl = priceData?.memberPriceValue ? this.section.querySelector('.quick-add-info__details .product-price .price__member') : this.section.querySelector('.quick-add-info__details .product-price .price__default');
      //   const quickAddUnitPriceEl = quickAddUnitPriceContainerEl?.querySelector?.('.price__current');
      //   if (quickAddUnitPriceEl && priceCurrent) {
      //     quickAddUnitPriceEl.innerHTML = calculatedUnitPriceCurrent
      //   }
  
      //   const quickAddUnitPriceWasEl = quickAddUnitPriceContainerEl?.querySelector?.('.price__was');
      //   if (quickAddUnitPriceWasEl) {
      //     quickAddUnitPriceWasEl.innerHTML = calculatedUnitPriceWas
      //   } else {
      //     const newQuickAddUnitPriceWasEl = document.createElement('s');
      //     newQuickAddUnitPriceWasEl.classList.add('price__was');
      //     newQuickAddUnitPriceWasEl.setAttribute('data-no-update-when-quantity-change', 'true');
      //     newQuickAddUnitPriceWasEl.innerHTML = calculatedUnitPriceWas

      //     quickAddUnitPriceContainerEl?.appendChild?.(newQuickAddUnitPriceWasEl);
      //   }
  
      //   const pdpSubtotalPriceContainerEl = this.section.querySelector('.product-info__block .product-info__price');
      //   const pdpSubtotalPriceEl = pdpSubtotalPriceContainerEl?.querySelector?.('[data-subtotal-member-price]');
      //   if (pdpSubtotalPriceEl && priceCurrent) {
      //     pdpSubtotalPriceEl.innerHTML = calculatedSubtotalPriceCurrent
      //   }
  
      //   const pdpSubtotalPriceWasEl = pdpSubtotalPriceContainerEl?.querySelector?.('[data-subtotal-member-price-was-value]');
      //   if (pdpSubtotalPriceWasEl) {
      //     pdpSubtotalPriceWasEl.innerHTML = calculatedSubtotalPriceWas;
      //   } else if (calculatedSubtotalPriceWas > calculatedSubtotalPriceCurrent) {
      //     const newPdpSubtotalPriceWasEl = document.createElement('s');
      //     newPdpSubtotalPriceWasEl.classList.add('price__was');
      //     newPdpSubtotalPriceWasEl.setAttribute('data-subtotal-member-price-was', '');
      //     newPdpSubtotalPriceWasEl.setAttribute('data-subtotal-member-price-was-value', priceWas);
      //     newPdpSubtotalPriceWasEl.innerHTML = calculatedSubtotalPriceWas

      //     pdpSubtotalPriceContainerEl?.appendChild?.(newPdpSubtotalPriceWasEl);
      //   }
  
      //   const pdpUnitPriceContainerEl = priceData?.memberPriceValue ? this.section.querySelector('.product-info__unit-price .price-wrapper .price__member') : this.section.querySelector('.product-info__unit-price .price-wrapper .price__default');
      //   const pdpUnitPriceEl = pdpUnitPriceContainerEl?.querySelector?.('.price__current');
      //   if (pdpUnitPriceEl && priceCurrent) {
      //     pdpUnitPriceEl.innerHTML = calculatedUnitPriceCurrent
      //   }
  
      //   const pdpUnitPriceWasEl = pdpUnitPriceContainerEl?.querySelector?.('.price__was');
      //   if (pdpUnitPriceWasEl) {
      //     pdpUnitPriceWasEl.innerHTML = calculatedUnitPriceWas
      //   } else {
      //     const newPdpUnitPriceWasEl = document.createElement('s');
      //     newPdpUnitPriceWasEl.classList.add('price__was');
      //     newPdpUnitPriceWasEl.setAttribute('data-no-update-when-quantity-change', 'true');
      //     newPdpUnitPriceWasEl.innerHTML = calculatedUnitPriceWas

      //     pdpUnitPriceContainerEl?.appendChild?.(newPdpUnitPriceWasEl);
      //   }
      // }

      this.price = this.price || this.section.querySelector('.price-wrapper > .price, .product-price > .price');
      if(this.productContainer.nodeName === 'QUICK-ADD-DRAWER') this.price = this.section.querySelector(".product-price");
      if (!this.price) return;

      let { variant } = this;
      if (this.preSelection) {
        variant = this.data.product.variants[0];
        for (let i = 1; i < this.data.product.variants.length; i += 1) {
          if (this.data.product.variants[i].price < variant.price) variant = this.data.product.variants[i];
        }
      }

      if (this.variant) {
        const priceMemberEl = this.price.querySelector('.price__member-value')
        const priceCurrentEl = this.price.querySelector('.price__current');
        const updatePriceCurrent = priceCurrentEl?.getAttribute('data-no-update-when-quantity-change') !== true && priceCurrentEl?.getAttribute('data-no-update-when-quantity-change') !== 'true';
        const priceWasEl = this.price.querySelector('.price__was');
        const updatePriceWas = priceWasEl?.getAttribute('data-no-update-when-quantity-change') !== true && priceWasEl?.getAttribute('data-no-update-when-quantity-change') !== 'true';
        const unitPriceEl = this.price.querySelector('.unit-price');
        const subtotalPriceEl = this.section.querySelector('[data-subtotal-price]');
        const subtotalMemberPriceEl = this.section.querySelector('[data-subtotal-member-price]');
        const quantityInputEl = this.section.querySelector('input[name="quantity"]');

        // Update member price
        if (priceMemberEl) {
          const memberPrice = this.data.formatted[this.variant.id].memberPrice || ''
          priceMemberEl.innerHTML = memberPrice;
          if (quantityInputEl) {
            subtotalMemberPriceEl.innerHTML = calcSubtotal(memberPrice, quantityInputEl.value);
          }
        }

        // Update current price and original price if on sale.
        const originalPrice = this.data.formatted[this.variant.id].price;
        if (updatePriceCurrent && priceCurrentEl) {
          priceCurrentEl.innerHTML = originalPrice;
        }
        if (quantityInputEl && subtotalPriceEl) {
          subtotalPriceEl.innerHTML = calcSubtotal(originalPrice, quantityInputEl.value);;
        }

        if (priceWasEl && updatePriceWas)
          priceWasEl.innerHTML = this.data.formatted[this.variant.id].compareAtPrice || '';

        // Update unit price, if specified.
        if (this.variant.unit_price_measurement) {
          const valueEl = this.price.querySelector('.unit-price__price');
          const unitEl = this.price.querySelector('.unit-price__unit');
          const value = this.variant.unit_price_measurement.reference_value;
          const unit = this.variant.unit_price_measurement.reference_unit;

          valueEl.innerHTML = this.data.formatted[this.variant.id].unitPrice;
          unitEl.textContent = value === 1 ? unit : `${value} ${unit}`;
        }

        if (unitPriceEl) {
          unitPriceEl.hidden = !this.variant.unit_price_measurement;
        }
        this.price.classList.toggle(
          'price--on-sale',
          this.variant.compare_at_price > this.variant.price
        );
        this.price.classList.toggle('price--sold-out', !this.variant.available && !this.preSelection);
      }

      if (this.price.querySelector('.price__default')) {
        this.price.querySelector('.price__default').hidden = !this.variant && !this.preSelection;
      }
      if (this.price.querySelector('.price__no-variant')) {
        this.price.querySelector('.price__no-variant').hidden = this.variant || this.preSelection;
      }
      const from = this.price.querySelector('.price__from');
      if (from) {
        from.hidden = !this.preSelection;
      }
    }

    /**
     * Updates the weight.
     */
    updateWeight() {
      this.weights = this.weights || this.section.querySelectorAll('.product-info__weight');
      if (this.weights.length === 0 || !this.variant?.id) return;

      const weightAvailable = this.variant && this.variant.weight > 0;
      this.weights.forEach((weight) => {
        weight.textContent = weightAvailable ? this.data.formatted[this.variant.id].weight : '';
        weight.hidden = !weightAvailable;
      });
    }

    /**
     * Updates the Barcode.
     */
    updateBarcode() {
      this.barcodes = this.barcodes || this.section.querySelectorAll('.product-info__barcode-value');
      if (this.barcodes.length === 0) return;

      const barcodeAvailable = this.variant && this.variant.barcode;
      this.barcodes.forEach((barcode) => {
        barcode.textContent = barcodeAvailable ? this.variant.barcode : '';
        barcode.parentNode.hidden = !barcodeAvailable;
      });
    }

    /**
     * Updates the Compatible Synthesizer.
     */
    updateCompatibleSynthesizer() {
      this.compatibleSynthesizer = this.compatibleSynthesizer || this.section.querySelector('.product-compatible-synthesizer');
      if (!this.compatibleSynthesizer) return;

      const compatibleSynthesizerValue = this.variant ? this.data.formatted[this.variant.id]?.compatibleSynthesizer : null;
      
      if (compatibleSynthesizerValue) {
        const compatibleSynthesizerValueEl = this.compatibleSynthesizer.querySelector('.product-compatible-synthesizer__value');
        if (compatibleSynthesizerValueEl) {
          compatibleSynthesizerValueEl.textContent = compatibleSynthesizerValue;
        }
        this.compatibleSynthesizer.hidden = false;
      } else {
        this.compatibleSynthesizer.hidden = true;
      }
    }

    /**
     * Updates the Short Title.
     */
    updateShortTitle() {
      const shortContainers = this.section.querySelectorAll('.js-short-title');
      const originalContainers = this.section.querySelectorAll('.js-original-title');
      if (!shortContainers.length || !originalContainers.length) return;

      let shortTitleContent = '';

      if (this.variant) {
        const newShort = this.sectionHTMLData.querySelector('.js-short-title');
        if (newShort) {
          shortTitleContent = newShort.innerHTML.trim();
        }
      }
      if (!this.variant) {
        const newShort = this.sectionHTMLData.querySelector('.js-original-title');
        if (newShort) {
          shortTitleContent = newShort.innerHTML.trim();
        }
      }

      const hasShortTitle = shortTitleContent && shortTitleContent !== '';

      shortContainers.forEach(el => {
        el.textContent = hasShortTitle ? shortTitleContent : '';
        el.style.display = hasShortTitle ? '' : 'none';
      });

      originalContainers.forEach(el => {
        el.style.display = hasShortTitle ? 'none' : '';
      });
    }


    /**
     * Updates the SKU.
     */
    updateSku() {
      this.sku = this.sku || this.section.querySelector('.product-sku__value');
      if (!this.sku) return;


      const skuAvailable = this.variant && this.variant.sku;
      this.sku.textContent = skuAvailable ? this.variant.sku : '';
      this.sku.parentNode.hidden = !skuAvailable;
    }

    updateCatalogNo() {
      this.catalogNo = this.catalogNo || this.section.querySelector('.product-catalog-no');
      if (!this.catalogNo || !this.variant?.id) return;

      this.catalogNo.innerHTML = this?.data?.formatted?.[this.variant.id]?.catalogNo;
    }

    updateHighlightedSpecs() {
      if (typeof wcPDPVariantsHtml === 'undefined') return;
      this.highlightedSpecs = this.highlightedSpecs || this.section.querySelector('.wc-product-highlighted-specs');
      if (!this.highlightedSpecs || !wcPDPVariantsHtml || !this.variant?.id) return;

      const content = wcPDPVariantsHtml[this.variant.id]?.highlightedSpecifications || '';
      this.highlightedSpecs.innerHTML = content;
    }

    updateAvailableForRetail() {
      this.productContainer = this.productContainer || this.closest('.js-product');
      if (!this.productContainer) return;
      this.productContainer.classList.toggle('unavailable-product', !this.variant);
      this.productContainer.classList.toggle('not-available-for-retail', (this.variant && (this.data.formatted[this.variant.id].availableForRetail === 'no' || !this.data.formatted[this.variant.id].availableForRetail)));
      const variantAvailable = this.variant && this.variant.available;
      this.productContainer.classList.toggle('is-sold-out', !variantAvailable);
    }

    updateSpecsTab() {
      if (typeof wcPDPVariantsHtml === 'undefined') return;
      this.specsTabPanels = this.specsTabPanels || this.section.querySelectorAll('.js-product-specifications');
      if (!this.specsTabPanels || !this.specsTabPanels.length || !wcPDPVariantsHtml || !this.variant?.id) return;
      const specsHtml = wcPDPVariantsHtml[this.variant.id]?.specifications || '';
      this.specsTabPanels.forEach(elm => {
        elm.innerHTML = specsHtml;
        if (specsHtml == '<table></table>') {
          elm.classList.add('hidden');
        } else {
          elm.classList.remove('hidden');
        }
      });
    }

    updateMetafieldContent() {
      if (typeof wcPDPVariantsHtml === 'undefined' || !this.variant?.id) return;
      this.metafieldContents = this.metafieldContents || this.section.querySelectorAll('[data-variant-metafield-key]');
      if (!wcPDPVariantsHtml || !wcPDPMetafieldKeys.length || !this.metafieldContents?.length || !this.variant?.id) return;

      this.metafieldContents.forEach(elm => {
        const key = elm.getAttribute('data-variant-metafield-key');
        const contentHTML = this.sectionHTMLData.querySelector(`[data-variant-metafield-key="${key}"]`);
        const content = contentHTML?.innerHTML || wcPDPVariantsHtml[this.variant.id][key] || wcPDPVariantsHtml[this.variant.id][`${key}_fallback_content`] || '';
        elm.innerHTML = content;
        elm.closest('details-disclosure').style.display = content ? '' : 'none';
      })
    }

    /**
     * Updates the url with the selected variant id.
     * @param {object} evt - Event object.
     */
    updateUrl(evt) {
      if (!evt || evt.type !== 'change' || this.dataset.updateUrl === 'false' || !this.variant?.id) return;
      window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.variant.id}`);
    }

    /**
     * Updates the value of the hidden [name="id"] form inputs.
     */
    updateVariantInput() {
      this.forms =
        this.forms || this.section.querySelectorAll('.js-product-form-main, .js-instalments-form');

      this.forms.forEach((form) => {
        const input = form.querySelector('input[name="id"]');
        input.value = this.variant?.id;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }

    updateEstimateArriveDate() {
      if (!this.variant?.id) return;
      const estimateArriveDateEl = this.section.querySelector('.estimate-arrive-date');
      if (estimateArriveDateEl) {
        estimateArriveDateEl.innerHTML = this.sectionHTMLData.querySelector('.estimate-arrive-date').innerHTML;
      }
    }

    updateEstimateRestockDate() {
      if (!this.variant?.id) return;
      const estimateRestockDateEl = this.section.querySelector('.estimate-restock-date');
      if (estimateRestockDateEl) {
        estimateRestockDateEl.innerHTML = this.sectionHTMLData.querySelector('.estimate-restock-date').innerHTML;
      }
    }

    /**
     * Gets the selected option element from each selector.
     * @returns {Array}
     */
    getSelectedOptions() {
      const selectedOptions = [];

      this.optionSelectors.forEach((selector) => {
        if (selector.dataset.selectorType === 'dropdown') {
          const selectedText = selector.querySelector('.custom-select__btn').textContent.trim();
          selectedOptions.push(selectedText === this.dataset.placeholderText ? null : selectedText);
        } else {
          const selected = selector.querySelector('input:checked');
          selectedOptions.push(selected ? selected.value : null);
        }
      });

      return selectedOptions;
    }

    /**
     * Gets the product data.
     * @returns {?object}
     */
    getProductData() {
      const dataEl = this.querySelector('[type="application/json"]');
      return JSON.parse(dataEl.textContent);
    }

    /**
     * Get selected variant data.
     * @returns {?object} Variant object, or null if one is not selected.
     */
    getSelectedVariant() {
      const selectedOptions = this.getSelectedOptions();
      return this.data.product.variants.find(
        (v) => v.options.every((val, index) => val === selectedOptions[index])
      );
    }

    updateQuantityInput() {
      const quantityInputEl = this.section.querySelector('input[name="quantity"]');
      if (quantityInputEl) {
        quantityInputEl.value = 1;
        document.dispatchEvent(new CustomEvent('wc-init:subtotal-quick-add-update-immediately'));
      }
    }
  }

  customElements.define('variant-picker', VariantPicker);
}
